import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {
  ComisionComponent, LiquidarComisionesComponent,
  ListaComisionesComponent,
  NewComisionesComponent, NewComisionTiendaComponent,
  ViewComisionesComponent
} from './components/comision.component';
import {ComisionesSecurityServices} from './services/comisiones.security.services';
import {ReporteComisionMensual} from './components/reportes/reporte.comision.mensual';
import {ComisionIndividualComponent} from './components/comision.individual.component';


const appRoutes:Routes =[
  {path:"comisiones", component:ListaComisionesComponent, canActivate:[ComisionesSecurityServices]},
  {path:"comisiones/new", component:NewComisionesComponent, canActivate:[ComisionesSecurityServices]},
  {path:"comisiones/newTienda", component:NewComisionTiendaComponent, canActivate:[ComisionesSecurityServices]},
  {path:"comisiones/newIndividual", component:ComisionIndividualComponent, canActivate:[ComisionesSecurityServices]},
  {path:"comisiones/view/:id", component:ViewComisionesComponent, canActivate:[ComisionesSecurityServices]},
  {path:"comisiones/liquidar/:id", component:LiquidarComisionesComponent, canActivate:[ComisionesSecurityServices]},
  {path:"comisiones/reporte", component:ReporteComisionMensual}


];


@NgModule({
  imports:[RouterModule.forChild(appRoutes)],
  exports:[RouterModule]
})
export class ComisionesRoutingModule {

}
